export default function SkillsLearned() {
  const skills = [
    { icon: 'ri-message-3-line', title: 'Начало переписки', desc: 'Как заинтересовать клиента за первые 2–3 сообщения. Приветствие, которое выделяет вас среди конкурентов.' },
    { icon: 'ri-search-eye-line', title: 'Выявление потребностей', desc: 'Как задавать вопросы письменно, чтобы клиент раскрывал реальные потребности, а не отвечал односложно.' },
    { icon: 'ri-vip-crown-line', title: 'Продажа ценности', desc: 'Как объяснять преимущества без огромных текстов. Формула короткой и убедительной аргументации.' },
    { icon: 'ri-chat-check-line', title: 'Работа с возражениями', desc: 'Возражения в переписке отличаются от телефонных. Как отрабатывать их уверенно и без скидок.' },
    { icon: 'ri-hand-heart-line', title: 'Закрытие сделки', desc: 'Как вести клиента до оплаты через переписку. Мягкий, но уверенный переход к действию.' },
    { icon: 'ri-repeat-line', title: 'Follow-up', desc: 'Когда писать, что писать, как напоминать. Система сопровождения клиента без назойливости.' },
    { icon: 'ri-user-voice-line', title: 'Работа с молчанием клиента', desc: 'Как вернуть клиента в диалог после паузы. Техники реактивации без давления и спама.' },
    { icon: 'ri-stack-line', title: 'Upsell и Cross-sell', desc: 'Как предлагать дополнительные продукты и услуги в переписке естественно и без навязчивости.' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-50 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-book-open-line"></i>
            Программа обучения
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Чему обучаются сотрудники
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Программа охватывает весь цикл продажи в переписке — от первого сообщения до повторных продаж.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {skills.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="w-12 h-12 bg-teal-600/10 rounded-xl flex items-center justify-center flex-shrink-0 mb-4 group-hover:bg-teal-600/15 transition-colors">
                <i className={`${item.icon} text-teal-600 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}